import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import HitCard from 'Components/Cards/HitCard';
import { fetchTopSellers } from 'Redux/ducks/algolia-calls';
import { IsChallenger } from 'Redux/ducks/split-test';

export default function NoResults({ stats, pathname }) {
  const [hits, setHits] = useState(null);

  useEffect(() => {
    const fetchHits = async () => {
      setHits([]);
      const result = await fetchTopSellers('all', 12);
      setHits(result.hits);
    };

    fetchHits();
  }, []);

  if (stats) {
    return false;
  }

  return (
    <div className="pt-5 container">
      <div className="d-flex flex-column align-items-center">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        <h3 className="pt-3">
          <FormattedMessage id="no-results.help" defaultMessage="We couldn't find any results for you." />
        </h3>
        {pathname !== '/on-sale' && IsChallenger('NoResultsTopSellers') ?
          <p>
            <FormattedMessage
              id="no-results.search-terms"
              defaultMessage="Try adjusting the terms of your search or check out our {navlink} below"
              values={{
                navlink: <Link to="/top-sellers" className="text-primary">
                  <FormattedMessage id="no-results.latest-deals" defaultMessage="Top Sellers" />
                </Link>,
              }}
            />
          </p> :
          <p>
            <FormattedMessage
              id="no-results.top-sellers-text"
              defaultMessage="Try adjusting the terms of your search or {navlink}"
              values={{
                navlink: <Link to="/latest-deals" className="text-primary">
                  <FormattedMessage id="no-results.top-sellers" defaultMessage="Click here to check out our latest deals." />
                </Link>,
              }}
            />
          </p>
        }
      </div>
      {(!isEmpty(hits) && pathname !== '/on-sale' && IsChallenger('NoResultsTopSellers')) &&
        <>
          <ul className="HitCardsRow row pt-3">
            {hits.slice(0, 12).map((hit, i) =>
              <HitCard
                key={hit.objectID}
                hit={hit}
                lgSize={4}
                smSize={6}
                lazy={i >= 6}
                hitCardContainerTag="li"
                hitCardNameTag="h2"
                coverTypeOverride={null}
                adaptiveSize={false}
              />,
            )}
          </ul>
        </>
      }
    </div>
  );
}

NoResults.propTypes = {
  stats: PropTypes.number,
};

NoResults.defaultProps = {
  stats: 0,
};
